import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-gradient-to-r from-orange-50 via-pink-50 to-yellow-50 shadow-lg sticky top-0 z-50 border-b-4 border-orange-300">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer group">
            <div className="w-16 h-16 flex items-center justify-center transform group-hover:scale-110 transition-transform">
              <img 
                src="https://static.readdy.ai/image/34c54877ea329bad86119ae5706d9da2/b68a85387ffbddbea6107dda1317d9b3.png" 
                alt="Tenny & Co Artistry Logo"
                className="w-full h-full object-contain drop-shadow-lg"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
                Tenny & Co Artistry
              </h1>
              <p className="text-xs text-gray-600 font-semibold">We have got much to offer</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`whitespace-nowrap font-bold transition-all cursor-pointer text-lg ${isActive('/') ? 'text-orange-600 scale-110' : 'text-gray-700 hover:text-orange-600 hover:scale-105'}`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`whitespace-nowrap font-bold transition-all cursor-pointer text-lg ${isActive('/about') ? 'text-orange-600 scale-110' : 'text-gray-700 hover:text-orange-600 hover:scale-105'}`}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`whitespace-nowrap font-bold transition-all cursor-pointer text-lg ${isActive('/services') ? 'text-orange-600 scale-110' : 'text-gray-700 hover:text-orange-600 hover:scale-105'}`}
            >
              Services
            </Link>
            <Link 
              to="/portfolio" 
              className={`whitespace-nowrap font-bold transition-all cursor-pointer text-lg ${isActive('/portfolio') ? 'text-orange-600 scale-110' : 'text-gray-700 hover:text-orange-600 hover:scale-105'}`}
            >
              Portfolio
            </Link>
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold transition-all cursor-pointer shadow-lg transform hover:scale-105 text-lg"
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-12 h-12 flex items-center justify-center text-orange-600 hover:text-pink-600 cursor-pointer bg-white rounded-full shadow-lg"
          >
            <i className={`text-3xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-orange-200 pt-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`whitespace-nowrap font-bold transition-colors cursor-pointer text-lg ${isActive('/') ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'}`}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => setIsMenuOpen(false)}
                className={`whitespace-nowrap font-bold transition-colors cursor-pointer text-lg ${isActive('/about') ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'}`}
              >
                About
              </Link>
              <Link 
                to="/services" 
                onClick={() => setIsMenuOpen(false)}
                className={`whitespace-nowrap font-bold transition-colors cursor-pointer text-lg ${isActive('/services') ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'}`}
              >
                Services
              </Link>
              <Link 
                to="/portfolio" 
                onClick={() => setIsMenuOpen(false)}
                className={`whitespace-nowrap font-bold transition-colors cursor-pointer text-lg ${isActive('/portfolio') ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'}`}
              >
                Portfolio
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMenuOpen(false)}
                className="whitespace-nowrap bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-6 py-3 rounded-full font-bold transition-all cursor-pointer text-center shadow-lg"
              >
                Contact Us
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}